import { Link, LinkProps } from '../Link/Link';
import { Text } from '../Text/Text';
import styles from './titleAndLink.module.scss';

export interface TitleAndLinkProps {
    link?: LinkProps;
    text: React.ReactNode;
}

export default function TitleAndLink({ text, link }: TitleAndLinkProps) {
    return (
        <div className={styles.container}>
            <Text tag="h3" variant="h3">
                {text}
            </Text>

            {!!link?.href && <Link {...link} ref={null} dataCy="atoms-title-and-link-link" />}
        </div>
    );
}
